var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 22",
    style: {
      enableBackground: "new 0 0 18 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#464646;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,3.2h-0.2c-0.9-1.7-2.4-2.8-4.1-2.8S5.9,1.5,5,3.2H4.4c-2.7,0-3.4,2.5-4,14c0,2.6,1.6,4.4,3.8,4.4h9.3 c1.1,0,2.2-0.5,2.8-1.4c0.6-0.9,1-1.9,1-3.1C16.8,5.8,16.1,3.2,13.3,3.2z M9.1,1.6c1,0,2,0.6,2.6,1.6H6.5C7.1,2.2,8.1,1.6,9.1,1.6z  M15.4,19.5c-0.4,0.6-1.1,0.9-1.8,0.9H4.2c-1.5,0-2.6-1.3-2.6-3.2C2.2,5.6,2.9,4.4,4.4,4.4h0.1C4.3,5.1,4.2,5.9,4.2,6.7 c0,0.3,0.3,0.6,0.6,0.6S5.4,7,5.4,6.7c0-0.9,0.2-1.6,0.4-2.3h6.5c0.3,0.7,0.4,1.5,0.4,2.3c0,0.3,0.3,0.6,0.6,0.6S14,7,14,6.7 c0-0.8-0.1-1.6-0.3-2.3c1.4,0.3,2,2.6,2.5,12.8C16.1,18,15.9,18.8,15.4,19.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolsa);
export default __webpack_public_path__ + "static/media/bolsa.aacb18e091c5bd19751d833194e8245a.svg";
export { ForwardRef as ReactComponent };